module.exports = "/images/circle-marker-car-1-5.png?43b1e3d216a34c65df5776d84e7350d0";